import { useState } from "react";

const useEnableScroll = () => {
  const [enableScroll, setEnableScroll] = useState(false);

  const mouseEnterLeave = isEnter => {
    setEnableScroll(isEnter);
  };
  return { enableScroll, mouseEnterLeave };
};

export default useEnableScroll;
